import ConditionalRoute from "./ConditionalRoute";
import AfterAuthLocation from "src/components/Routing/AfterAuthLocation";

const UnprotectedRoute = ConditionalRoute({
  bad: true,
  to: () => AfterAuthLocation.get(),
});

export default UnprotectedRoute;
